module.exports = __webpack_public_path__ + "images/blog/blog_card/questions/21_b9d7a0e3fa5e08ec32b3c3dfa6dd318c.jpg";